import { createAction } from "typesafe-actions";

import type { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";
import type {
    IFindAppsCommonRequestParamsDto,
    IFindAppsCommonRowDto,
} from "app/pages/sales-intelligence/store/find-apps/types/dto";
import type { IFindAppsState } from "app/pages/sales-intelligence/store/find-apps/types/state";

type FindAppsActionModel<T> = [AppsSourceType, T];

type FindAppsTabState = Pick<IFindAppsState, AppsSourceType>[AppsSourceType];

export const setActiveAppSourceType = createAction("@@si/find-apps/set-active-app-source-type")<AppsSourceType>();

export const setIsRowSelectionEnabled = createAction("@@si/find-apps/set-is-row-selection-enabled")<boolean>();

export const setSelectedRows = createAction("@@si/find-apps/set-selected-rows")<
    ReadonlyArray<IFindAppsCommonRowDto & { key: React.Key }>
>();

export const findAppsUpdateFilters = createAction("@@si/find-apps/update-filters")<
    FindAppsActionModel<Partial<FindAppsTabState["request"]["filters"]>>
>();

export const findAppsUpdateSearchText = createAction("@@si/find-apps/update-search-text")<
    FindAppsActionModel<string>
>();

export const findAppsUpdateSearchParams = createAction("@@si/find-apps/update-search-params")<
    FindAppsActionModel<Partial<IFindAppsCommonRequestParamsDto>>
>();

export const findAppsUpdateExpandedFilter = createAction("@@si/find-apps/pagination-params")<
    FindAppsActionModel<string | null>
>();

export const resetFindAppsState = createAction("@@si/find-apps/reset")();
